import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

export const CounterPill: FC<ComponentPropsWithoutRef<'span'>> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        `
          flex h-[calc(var(--spacing-4xl)/2)] min-w-3xl items-center
          justify-center rounded-full bg-background-surface-selected p-0 px-md
          py-0 text-label-sm font-label-semibold
          text-foreground-surface-selected
        `,
        className
      )}
      {...props}
    />
  );
};
